import React from "react";

import { Button } from "@material-ui/core";

import { useFormikContext } from "formik";

const ModalFormActions = ({
  closeModalText,
  closeModal,
  onSubmitActionText,
  ...props
}) => {
  const form = useFormikContext();

  return (
    <>
      <Button 
        color="secondary" 
        onClick={closeModal}
        variant="outlined"
        disabled={form.isSubmitting}
      >
        {closeModalText}
      </Button>
      <Button
        color="primary"
        variant="contained"
        disabled={form.isSubmitting || !form.isValid}
        onClick={props.onClick}
      >
        {onSubmitActionText}
      </Button>
    </>
  );
};

export default ModalFormActions;
